class GiftWrapProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.handleRadio = this.handleRadio.bind(this)

    this.listeners.add(this.els.textarea.element, 'input', this.handleChange)
    this.listeners.add(this.els.apply.element, 'click', this.handleApply)

    this.els.radio.elements.forEach((radioEl) => {
      this.listeners.add(radioEl, 'click', this.handleRadio)
    })
  }

  handleChange () {
    // const count = this.els.textarea.element.value.length
    // this.els.count.element.innerHTML = count
  }

  async handleApply () {
    // const giftMessage = this.els.textarea.element.value
    // const matchedGiftMessageEl = this.externalEls.giftmessage.elements.find(
    //   (giftmessageEl) => {
    //     return giftmessageEl.dataset.formId === this.formId
    //   },
    // )
    // const matchedMessageStatusEl =
    //   this.externalEls.messagestatus.elements.find((messagestatusEl) => {
    //     return messagestatusEl.dataset.formId === this.formId
    //   })
    // matchedGiftMessageEl.value = giftMessage
    // if (giftMessage === '') {
    //   matchedGiftMessageEl.setAttribute('disabled', '')
    //   matchedMessageStatusEl.innerText = matchedMessageStatusEl.dataset.add
    // } else {
    //   matchedGiftMessageEl.removeAttribute('disabled')
    //   matchedMessageStatusEl.innerText = matchedMessageStatusEl.dataset.edit
    // }
  }

  handleRadio (event) {}

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get formId () {
    return this.dataset.formId
  }
}

if (!customElements.get('gift-wrap-product-card')) {
  customElements.define('gift-wrap-product-card', GiftWrapProductCard)
}
